import React from "react";

export default () => (
	<div className="tab">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54"><path d="M2.9 45.3h48.8v5.4H2.9v-5.4zm12.8-7.7l20-20v10.2h5.4V8.3H21.6v5.4h10.2l-20 20 3.9 3.9z"/></svg>
    Share
  </div>
)